import MetaMask from '../../src/legacy/MetaMask.tsx';
export default MetaMask;
